/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";
import WebsiteFeaturedProfilesManagementDash from "../../components/WebsiteFeaturedProfilesManagement";
import { WEBSITE_FEATURED_PROFILE_TYPES } from "../../components/WebsiteFeaturedProfilesManagement/helper";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const WebsiteMentorsManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.websiteMentors?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <WebsiteFeaturedProfilesManagementDash
        profileType={WEBSITE_FEATURED_PROFILE_TYPES.MENTOR}
        userConfig={userConfig}
        ROOT_URL={ROOT_URL}
      />
    </>
  );
};

export default WebsiteMentorsManagement;
